import { render, staticRenderFns } from "./AddNewDriver.vue?vue&type=template&id=c5a74d2c&scoped=true&lang=html&"
import script from "./AddNewDriver.vue?vue&type=script&lang=js&"
export * from "./AddNewDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a74d2c",
  null
  
)

export default component.exports